import { render, staticRenderFns } from "./fxReport.vue?vue&type=template&id=52e1e094&scoped=true"
import script from "./fxReport.vue?vue&type=script&lang=js"
export * from "./fxReport.vue?vue&type=script&lang=js"
import style0 from "./fxReport.vue?vue&type=style&index=0&id=52e1e094&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e1e094",
  null
  
)

export default component.exports